import { gql } from '@apollo/client';

export const queryString = gql`
  query Dealer($partnerId: String!, $language: String!) {
    dealerById(dealerId: $partnerId, language: $language) {
      dealerId
      displayName
      name
      phone
      url
      email
      address
      vCardUrl
      services
      longitude
      latitude
      zipCode
      street
      city
      country
      region
      openingHours {
        openingHoursNote
        departments {
          id
          departmentName
          departmentOpeningHoursNote
          openingHours {
            id
            open
            timeRanges {
              openTime
              closeTime
            }
          }
        }
      }
      additionalData {
        locationName
        locationImage
        additionalServices
        additionalUrl
      }
    }
  }
`;

export const getDealerQueryVariables = (partnerId: string | undefined, language: string) => ({
  partnerId,
  language,
});
